// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("./next/Next.bs.js");
let React = require("react");
let Scalars = require("../scalars/Scalars.bs.js");
let AuthSession = require("../utils/AuthSession.bs.js");
let PathHistory = require("./PathHistory.bs.js");
let QueryParams = require("./QueryParams.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Form__Helpers = require("./common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let PageViews_RecordPageViewV5Mutation_graphql = require("../__generated__/PageViews_RecordPageViewV5Mutation_graphql.bs.js");
let PageViews_RecordPageViewForLoggedInUserMutation_graphql = require("../__generated__/PageViews_RecordPageViewForLoggedInUserMutation_graphql.bs.js");

function make(page, resourceId, resourceType, secondaryResourceId, secondaryResourceType, qualifiedAgentId, data, param) {
  return {
    page: page,
    resourceId: resourceId,
    resourceType: resourceType,
    secondaryResourceId: secondaryResourceId,
    secondaryResourceType: secondaryResourceType,
    qualifiedAgentId: qualifiedAgentId,
    data: data
  };
}

function makePropertyPage(propertyId) {
  return make("PROPERTY_PAGE", propertyId, "PROPERTY", undefined, undefined, undefined, undefined, undefined);
}

function makePlansPage() {
  return {
    page: "PLANS_PAGE",
    resourceId: undefined,
    resourceType: undefined,
    secondaryResourceId: undefined,
    secondaryResourceType: undefined,
    qualifiedAgentId: undefined,
    data: undefined
  };
}

function makeBuyerNeedPage(buyerNeedId) {
  return make("BUYER_NEED_PAGE", buyerNeedId, "BUYER_NEED", undefined, undefined, undefined, undefined, undefined);
}

function makeAgentPage(agentId) {
  return make("AGENT_PAGE", agentId, "USER", undefined, undefined, undefined, undefined, undefined);
}

function makeAllInPage(messageId, qualifiedAgentId, secondaryResourceId, secondaryResourceType, param) {
  return make("ALL_IN_PAGE", messageId, "QA_MESSAGE", secondaryResourceId, secondaryResourceType, qualifiedAgentId, undefined, undefined);
}

function makePropertiesPage() {
  return {
    page: "PROPERTIES_PAGE",
    resourceId: undefined,
    resourceType: undefined,
    secondaryResourceId: undefined,
    secondaryResourceType: undefined,
    qualifiedAgentId: undefined,
    data: undefined
  };
}

function makeBuyerNeedsPage() {
  return {
    page: "BUYER_NEEDS_PAGE",
    resourceId: undefined,
    resourceType: undefined,
    secondaryResourceId: undefined,
    secondaryResourceType: undefined,
    qualifiedAgentId: undefined,
    data: undefined
  };
}

function makeShowingsPage() {
  return {
    page: "SHOWINGS_PAGE",
    resourceId: undefined,
    resourceType: undefined,
    secondaryResourceId: undefined,
    secondaryResourceType: undefined,
    qualifiedAgentId: undefined,
    data: undefined
  };
}

function makeActivityReportPage(entityType, entityId) {
  let tmp;
  switch (entityType) {
    case "BUYER_NEED" :
    case "RENTAL_NEED" :
      tmp = "client_need_";
      break;
    case "FOR_SALE_PROPERTY" :
    case "RENTAL_PROPERTY" :
      tmp = "property_";
      break;
  }
  let tmp$1;
  switch (entityType) {
    case "BUYER_NEED" :
      tmp$1 = "BUYER_NEED";
      break;
    case "RENTAL_NEED" :
      tmp$1 = "RENTAL_NEED";
      break;
    case "FOR_SALE_PROPERTY" :
    case "RENTAL_PROPERTY" :
      tmp$1 = "PROPERTY";
      break;
  }
  return make("ACTIVITY_REPORT_PAGE", tmp + entityId, "ACTIVITY_REPORT", entityId, tmp$1, undefined, undefined, undefined);
}

function makeChapterDashboardPage() {
  return {
    page: "CHAPTER_DASHBOARD_PAGE",
    resourceId: undefined,
    resourceType: undefined,
    secondaryResourceId: undefined,
    secondaryResourceType: undefined,
    qualifiedAgentId: undefined,
    data: undefined
  };
}

function makeConversationsPage(conversationId, secondaryResource, param) {
  return make("CONVERSATIONS_PAGE", conversationId, Stdlib_Option.map(conversationId, param => "CONVERSATION"), Stdlib_Option.map(secondaryResource, prim => prim[1]), Stdlib_Option.map(secondaryResource, prim => prim[0]), undefined, undefined, undefined);
}

function makeNewSellerPage() {
  return {
    page: "NEW_SELLER_PAGE",
    resourceId: undefined,
    resourceType: undefined,
    secondaryResourceId: undefined,
    secondaryResourceType: undefined,
    qualifiedAgentId: undefined,
    data: undefined
  };
}

function makeNewSharePropertyPage() {
  return {
    page: "SHARE_PROPERTY_PAGE",
    resourceId: undefined,
    resourceType: undefined,
    secondaryResourceId: undefined,
    secondaryResourceType: undefined,
    qualifiedAgentId: undefined,
    data: undefined
  };
}

function makeMailedPropertyPage(propertyId, emailNotificationId, emailNotificationOwnerId) {
  return make("MAILED_PROPERTY_PAGE", propertyId, "PROPERTY", emailNotificationId, "EMAIL_NOTIFICATION", undefined, Object.fromEntries([[
      "email_notification_owner_id",
      emailNotificationOwnerId
    ]]), undefined);
}

function makeMessagesPage() {
  return {
    page: "MESSAGES_PAGE",
    resourceId: undefined,
    resourceType: undefined,
    secondaryResourceId: undefined,
    secondaryResourceType: undefined,
    qualifiedAgentId: undefined,
    data: undefined
  };
}

let Page = {
  make: make,
  makePropertyPage: makePropertyPage,
  makePlansPage: makePlansPage,
  makeBuyerNeedPage: makeBuyerNeedPage,
  makeAgentPage: makeAgentPage,
  makeAllInPage: makeAllInPage,
  makePropertiesPage: makePropertiesPage,
  makeBuyerNeedsPage: makeBuyerNeedsPage,
  makeShowingsPage: makeShowingsPage,
  makeActivityReportPage: makeActivityReportPage,
  makeChapterDashboardPage: makeChapterDashboardPage,
  makeConversationsPage: makeConversationsPage,
  makeNewSellerPage: makeNewSellerPage,
  makeNewSharePropertyPage: makeNewSharePropertyPage,
  makeMailedPropertyPage: makeMailedPropertyPage,
  makeMessagesPage: makeMessagesPage
};

function tFromJs(s) {
  switch (s) {
    case "email" :
      return "EMAIL";
    case "web" :
      return "WEB";
    default:
      return;
  }
}

function tToJs(t) {
  if (t === "WEB") {
    return "web";
  } else {
    return "email";
  }
}

let Medium = {
  tFromJs: tFromJs,
  tToJs: tToJs
};

function decode(param) {
  return Stdlib_Option.flatMap(param, tFromJs);
}

function encode(param) {
  return Stdlib_Option.map(param, tToJs);
}

let MediumParam = {
  decode: decode,
  encode: encode
};

let config = Object.fromEntries([
  [
    "as_c",
    QueryParams.UseQueryParams.ParamConfigs.stringParam
  ],
  [
    "as_ca",
    QueryParams.UseQueryParams.ParamConfigs.stringParam
  ],
  [
    "as_s",
    QueryParams.UseQueryParams.ParamConfigs.stringParam
  ],
  [
    "as_m",
    {
      encode: encode,
      decode: decode
    }
  ]
]);

let ParamsConfig = {
  MediumParam: MediumParam,
  config: config
};

let UseQueryParams = QueryParams.UseQueryParams.Make({
  config: config
});

function anyIsPresent(x) {
  if (x.content !== undefined || x.campaign !== undefined || x.source !== undefined) {
    return true;
  } else {
    return x.medium !== undefined;
  }
}

function use() {
  let match = UseQueryParams.use();
  let setParams = match[1];
  let params = match[0];
  let params$p_content = params.as_c;
  let params$p_campaign = params.as_ca;
  let params$p_source = params.as_s;
  let params$p_medium = params.as_m;
  let params$p = {
    content: params$p_content,
    campaign: params$p_campaign,
    source: params$p_source,
    medium: params$p_medium
  };
  let clearParams = () => setParams("replaceIn", {
    as_c: undefined,
    as_ca: undefined,
    as_s: undefined,
    as_m: undefined
  });
  return [
    params$p,
    clearParams
  ];
}

function toQueryString(utm) {
  return new URLSearchParams(Stdlib_Array.filterMap([
    Stdlib_Option.map(utm.medium, m => [
      "as_m",
      tToJs(m)
    ]),
    Stdlib_Option.map(utm.campaign, ca => [
      "as_ca",
      ca
    ]),
    Stdlib_Option.map(utm.content, c => [
      "as_c",
      c
    ]),
    Stdlib_Option.map(utm.source, s => [
      "as_s",
      s
    ])
  ], x => x)).toString();
}

let UTM = {
  Medium: Medium,
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  anyIsPresent: anyIsPresent,
  use: use,
  toQueryString: toQueryString
};

let convertVariables = PageViews_RecordPageViewV5Mutation_graphql.Internal.convertVariables;

let convertResponse = PageViews_RecordPageViewV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = PageViews_RecordPageViewV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, PageViews_RecordPageViewV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, PageViews_RecordPageViewV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let RecordPageViewV5Mutation_mediumV5_decode = PageViews_RecordPageViewV5Mutation_graphql.Utils.mediumV5_decode;

let RecordPageViewV5Mutation_mediumV5_fromString = PageViews_RecordPageViewV5Mutation_graphql.Utils.mediumV5_fromString;

let RecordPageViewV5Mutation_pageV5_decode = PageViews_RecordPageViewV5Mutation_graphql.Utils.pageV5_decode;

let RecordPageViewV5Mutation_pageV5_fromString = PageViews_RecordPageViewV5Mutation_graphql.Utils.pageV5_fromString;

let RecordPageViewV5Mutation_pageViewViewerType_decode = PageViews_RecordPageViewV5Mutation_graphql.Utils.pageViewViewerType_decode;

let RecordPageViewV5Mutation_pageViewViewerType_fromString = PageViews_RecordPageViewV5Mutation_graphql.Utils.pageViewViewerType_fromString;

let RecordPageViewV5Mutation_resourceTypeV5_decode = PageViews_RecordPageViewV5Mutation_graphql.Utils.resourceTypeV5_decode;

let RecordPageViewV5Mutation_resourceTypeV5_fromString = PageViews_RecordPageViewV5Mutation_graphql.Utils.resourceTypeV5_fromString;

let RecordPageViewV5Mutation = {
  mediumV5_decode: RecordPageViewV5Mutation_mediumV5_decode,
  mediumV5_fromString: RecordPageViewV5Mutation_mediumV5_fromString,
  pageV5_decode: RecordPageViewV5Mutation_pageV5_decode,
  pageV5_fromString: RecordPageViewV5Mutation_pageV5_fromString,
  pageViewViewerType_decode: RecordPageViewV5Mutation_pageViewViewerType_decode,
  pageViewViewerType_fromString: RecordPageViewV5Mutation_pageViewViewerType_fromString,
  resourceTypeV5_decode: RecordPageViewV5Mutation_resourceTypeV5_decode,
  resourceTypeV5_fromString: RecordPageViewV5Mutation_resourceTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

let convertVariables$1 = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Internal.convertVariables;

let convertResponse$1 = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, PageViews_RecordPageViewForLoggedInUserMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, PageViews_RecordPageViewForLoggedInUserMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RecordPageViewForLoggedInUserMutation_mediumV5_decode = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.mediumV5_decode;

let RecordPageViewForLoggedInUserMutation_mediumV5_fromString = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.mediumV5_fromString;

let RecordPageViewForLoggedInUserMutation_pageV5_decode = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.pageV5_decode;

let RecordPageViewForLoggedInUserMutation_pageV5_fromString = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.pageV5_fromString;

let RecordPageViewForLoggedInUserMutation_resourceTypeV5_decode = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.resourceTypeV5_decode;

let RecordPageViewForLoggedInUserMutation_resourceTypeV5_fromString = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.resourceTypeV5_fromString;

let RecordPageViewForLoggedInUserMutation = {
  mediumV5_decode: RecordPageViewForLoggedInUserMutation_mediumV5_decode,
  mediumV5_fromString: RecordPageViewForLoggedInUserMutation_mediumV5_fromString,
  pageV5_decode: RecordPageViewForLoggedInUserMutation_pageV5_decode,
  pageV5_fromString: RecordPageViewForLoggedInUserMutation_pageV5_fromString,
  resourceTypeV5_decode: RecordPageViewForLoggedInUserMutation_resourceTypeV5_decode,
  resourceTypeV5_fromString: RecordPageViewForLoggedInUserMutation_resourceTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$2
};

function userAgent() {
  return window.navigator.userAgent;
}

function useRecordPageView(page) {
  let isImpersonated = AuthSession.useIsImpersonated();
  let match = use$2();
  let recordPageViewForLoggedInUser = match[0];
  let match$1 = use$1();
  let recordPageView = match$1[0];
  let history = React.useContext(PathHistory.Context.context);
  let router = Next.useRouter();
  let currentPath = Next.Router.asPath(router);
  let queryParams = new URLSearchParams(Next.Router.query(router));
  let previousPath = Stdlib_Option.flatMap(Stdlib_List.tail(history), Stdlib_List.head);
  let referrer = Stdlib_Option.flatMap(Webapi__Dom__Document.asHtmlDocument(document), doc => Form__Helpers.opt_of_string(doc.referrer));
  let userAgent$p = Form__Helpers.opt_of_string(userAgent());
  let match$2 = use();
  let clearUTMParams = match$2[1];
  let utm = match$2[0];
  let clearedParams = React.useRef(false);
  let mutate = () => {
    let match = utm.medium;
    let x = queryParams.toString();
    let tmp = x === "" ? undefined : x;
    let pageView_campaign = utm.campaign;
    let pageView_content = utm.content;
    let pageView_data = Stdlib_Option.map(page.data, d => d);
    let pageView_medium = match !== undefined ? (
        match === "WEB" ? "WEB" : "EMAIL"
      ) : undefined;
    let pageView_page = page.page;
    let pageView_resourceId = page.resourceId;
    let pageView_resourceType = page.resourceType;
    let pageView_secondaryResourceId = page.secondaryResourceId;
    let pageView_secondaryResourceType = page.secondaryResourceType;
    let pageView_source = utm.source;
    let pageView_viewedAt = Scalars.DateTime.fromJsDate(new Date());
    let pageView = {
      campaign: pageView_campaign,
      content: pageView_content,
      data: pageView_data,
      medium: pageView_medium,
      page: pageView_page,
      path: currentPath,
      previousPath: previousPath,
      queryParams: tmp,
      referrer: referrer,
      resourceId: pageView_resourceId,
      resourceType: pageView_resourceType,
      secondaryResourceId: pageView_secondaryResourceId,
      secondaryResourceType: pageView_secondaryResourceType,
      source: pageView_source,
      userAgent: userAgent$p,
      viewedAt: pageView_viewedAt
    };
    let qualifiedAgentId = page.qualifiedAgentId;
    if (qualifiedAgentId !== undefined) {
      recordPageView({
        input: {
          pageView: pageView,
          viewer: {
            viewerId: qualifiedAgentId,
            viewerType: "QA"
          }
        }
      }, undefined, undefined, undefined, undefined, undefined, undefined);
    } else {
      recordPageViewForLoggedInUser({
        input: {
          pageView: pageView
        }
      }, undefined, undefined, undefined, undefined, undefined, undefined);
    }
    let match$1 = anyIsPresent(utm);
    if (match$1) {
      clearUTMParams();
      clearedParams.current = true;
      return;
    }
  };
  let stringifiedPage = React.useMemo(() => JSON.stringify(page), [page]);
  React.useEffect(() => {
    if (clearedParams.current === true) {
      clearedParams.current = false;
    }
  }, [stringifiedPage]);
  React.useEffect(() => {
    if (isImpersonated && clearedParams.current === false) {
      
    } else {
      mutate();
    }
  }, [
    isImpersonated,
    stringifiedPage
  ]);
}

function PageViews$RecordPageView(props) {
  useRecordPageView(props.page);
  return null;
}

let RecordPageView = {
  make: PageViews$RecordPageView
};

exports.Page = Page;
exports.UTM = UTM;
exports.RecordPageViewV5Mutation = RecordPageViewV5Mutation;
exports.RecordPageViewForLoggedInUserMutation = RecordPageViewForLoggedInUserMutation;
exports.userAgent = userAgent;
exports.useRecordPageView = useRecordPageView;
exports.RecordPageView = RecordPageView;
/* config Not a pure module */
